export default "__VITE_ASSET__3962c71c__"